import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDatePicker, MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import MaterialTable from 'material-table';
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from "react-redux";
import { UiActions } from 'state/actions/UiActions';
import { InfluencerReportActions } from 'state/actions/user/InfluencerReportActions';
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';
import { PartnerInfoActions } from 'state/actions/user/PartnerInfoActions';
import { Utils } from 'utils/Utils';
import { tableIcons } from './TableIcons';

class AllInfluencers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reports: [],
      startDate: null,
      endDate: null,
      documentStatus: []
    }
  }

  componentDidMount() {
    const {
      history,
      person
    } = this.props;
    
    this.props.isAdmin(
      person.person.username,
      (response)=>{
        const isAdmin = response.result;
        if(!isAdmin){
          history.push("/");
        }
      });
    this.getDocumentStatus();

  }

  getDocumentStatus = () => {
    const token = this.props.token.Authorization;

    ExecuteRequest(
      GlamboxEndpoints.PersonDocumentStatus.get,
      null,
      "GET",
      {
        Authorization: token
      },
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;
        if (statusCode === 200) {
          let status =
            result.map((documentStatus) => {
              return documentStatus.status;
            });

          this.setState({
            documentStatus: status
          });
        }

      }
    );

  }

  renderDatePickers = () => {
    let { startDate, endDate } = this.state;
    return (
      <div>
        <h3 className={"display-3"}>
          Selecione um período
        </h3>

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            disableToolbar
            format="dd/MM/yyyy"
            margin="normal"
            id="date-picker-inline"
            label="Data início"
            value={startDate}
            onChange={this.updateStartDate}
            autoOk={true}
            okLabel={""}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label="Date fim"
            format="dd/MM/yyyy"
            value={endDate}
            onChange={this.updateEndDate}
            autoOk={true}
            okLabel={""}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </MuiPickersUtilsProvider>

        <button onClick={this.getReports}
          className={"btn btn-light-lime"}>
          Buscar
        </button>
      </div>

    );
  }

  strToDate = (date) => {
    let startDate = new Date(date);
    let month = (startDate.getMonth() + 1);
    let convertedDate = startDate.getFullYear() + "/" + month + "/" + startDate.getDate();

    return convertedDate;

  }

  updateStartDate = (date) => {
    let startDate = this.strToDate(date);
    this.setState({
      startDate: startDate
    });
  }

  updateEndDate = (date) => {
    let endDate = this.strToDate(date);

    this.setState({
      endDate: endDate
    });
  }

  renderAllInfluencers = () => {

    let { reports } = this.state;
    if (reports.length === 0) {
      return null;
    }

    let editable = {
      onRowUpdate: (newData, oldData) => {
        return new Promise((resolve, reject) => {
          let dataUpdate = [...reports];

          for (const n in dataUpdate) {
            if (dataUpdate[n].personId === newData.personId) {
              dataUpdate[n] = Object.assign({}, dataUpdate[n], newData);
            }
          }
          
          const payload =  this.getUpdatePayload(newData, oldData);
          
          this.updateData(payload, () => {
            this.setState({
              reports: dataUpdate
            });
            resolve();          

          });
        });
      },
      onBulkUpdate: (changes) => {
        return new Promise((resolve, reject) => {
          this.updateBulk(changes, () => resolve());
        });

      }
    }

    return (
      <MaterialTable
        columns={this.getHeaders()}
        data={reports}
        editable={editable}
        title="All Influencers"
        options={{
          columnsButton: true,
          exportButton: true,
          exportAllData: true,
          actionsColumnIndex: -1
        }}
        icons={tableIcons}
      />
    );

  }

  getUpdatePayload = (newData, oldData) =>{
    let payload = {
      influencerDocumentStatus: newData.documentStatus,
      personId: oldData.personId
    }

    return payload;
  }
  
  updateData = async (payload, callback) => {
   const token = this.props.token.Authorization;

   ExecuteRequest(
     GlamboxEndpoints.InfluencerDocument.putDocumentStatus,
     Object.assign({}, payload),
     'PUT',
     {
      Authorization: token
      },
      null,
      null
      );

    callback();
  }

  updateBulk = (changes, callback) => {

    for (let n in changes) {
      let newData = changes[n].newData;
      let oldData = changes[n].oldData;
      
      const payload = this.getUpdatePayload(newData, oldData);
      this.updateData(payload, callback);
    }
  }

  getReports = async () => {
    const { startDate, endDate } = this.state;
    if (!startDate || !endDate) return null;
    this.props.loaderShow();

    await this.props.getReports(startDate, endDate,
      (response) => {

        let {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          this.setState({
            reports: result.result
          });
        }
      });

      this.props.loaderHide();
  }

  getHeaders = () => {
    let headers = [
      { title: 'Name', field: 'name', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Enabled', field: 'enabled', editable: 'never', hiddenByColumnsButton: true },
      { title: 'PersonId', field: 'personId', editable: 'never', hiddenByColumnsButton: true },
      { title: 'SubscriberId', field: 'subscriberId', editable: 'never', hiddenByColumnsButton: true },
      {
        title: 'DateAccepted', field: 'dateAccepted', editable: 'never', hiddenByColumnsButton: true,
        render: (rowData) => {
          return rowData.dateAccepted ? Utils.tempConvertDate(rowData.dateAccepted) :null
        }
      },
      {
        title: 'DateCreatedInfluencer', field: 'dateCreatedInfluencer', editable: 'never', hiddenByColumnsButton: true,
        render: (rowData) => {
          return rowData.dateCreatedInfluencer ? Utils.tempConvertDate(rowData.dateCreatedInfluencer) : null
        }
      },
      { title: 'FirstName', field: 'firstName', editable: 'never', hiddenByColumnsButton: true },
      { title: 'LastName', field: 'lastName', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Email', field: 'email', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Phone', field: 'phone', editable: 'never', hiddenByColumnsButton: true },
      { title: 'CPF', field: 'cpf', editable: 'never', hiddenByColumnsButton: true },
      {
        title: 'Birthday', field: 'birthday', editable: 'never', hiddenByColumnsButton: true,
        render: (rowData) => {
          return rowData.birthday ?  Utils.tempConvertDate(rowData.birthday) : null
        }
      },
      {
        title: 'documentStatus', field: 'documentStatus', hiddenByColumnsButton: true,
        editComponent: props => {
          const { documentStatus } = this.state;
          return (
            this.renderStatusOptions(props, documentStatus)
          )
        }
      },
      {
        title: 'DocumentImage', field: 'documentImageUrl', editable: 'never', hiddenByColumnsButton: true,
        render: (rowData) => {
          return (
            <a href={rowData.documentImageUrl} target="_blank">
              <img src={rowData.documentImageUrl}
                style={{ width: 80 }} />
            </a>
          );
        }
      },
      { title: 'Blog', field: 'blog', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Facebook', field: 'facebook', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Instagram', field: 'Iinstagram', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Youtube', field: 'youtube', editable: 'never', hiddenByColumnsButton: true },
      { title: 'PerfilBeleza', field: 'perfilBeleza', editable: 'never', hiddenByColumnsButton: true },
      { title: 'VoucherNumber', field: 'number', editable: 'never', hiddenByColumnsButton: true },
      { title: 'VoucherStatusName', field: 'voucherStatusName', editable: 'never', hiddenByColumnsButton: true },
      { title: 'RecebendoCaixa', field: 'recebendoCaixa', editable: 'never', hiddenByColumnsButton: true },
      { title: 'ShippingStreet', field: 'shippingStreet', editable: 'never', hiddenByColumnsButton: true },
      { title: 'ShippingStreetNumber', field: 'shippingStreetNumber', editable: 'never', hiddenByColumnsButton: true },
      { title: 'ShippingStreetExtensions', field: 'shippingStreetExtens', editable: 'never', hiddenByColumnsButton: true },
      { title: 'ShippingNeighborhood', field: 'shippingNeighborhood', editable: 'never', hiddenByColumnsButton: true },
      { title: 'ShippingPostalCode', field: 'shippingPostalCode', editable: 'never', hiddenByColumnsButton: true },
      { title: 'ShippingCity', field: 'shippingCity', editable: 'never', hiddenByColumnsButton: true },
      { title: 'ShippingState', field: 'shippingState', editable: 'never', hiddenByColumnsButton: true },
      { title: 'PersonCoupon', field: 'personCoupon', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Vendeu', field: 'vendeu', editable: 'never', hiddenByColumnsButton: true },
      { title: 'VendasMensal', field: 'vendasMensal', editable: 'never', hiddenByColumnsButton: true },
      { title: 'VendasSemestral', field: 'vendasSemestral', editable: 'never', hiddenByColumnsButton: true },
      { title: 'VendasAnual', field: 'vendasAnual', editable: 'never', hiddenByColumnsButton: true },
      { title: 'TotalVendas', field: 'totalVendas', editable: 'never', hiddenByColumnsButton: true },
      { title: 'TotalComissao', field: 'totalComissao', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Rg', field: 'rg', editable: 'never', hiddenByColumnsButton: true },
      { title: 'InfluencerStatus', field: 'influencerStatus', editable: 'never', hiddenByColumnsButton: true },
      { title: 'PersonalUsedCoupon', field: 'couponName', editable: 'never', hiddenByColumnsButton: true },

    ]

    return headers;
  }

  strToDate = (date) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1);
    
    if(month === 13){
      month = 1;
    }
    
    let convertedDate = d.getFullYear() + "/" + month + "/" + d.getDate();
    return convertedDate;
  }

  renderStatusOptions = (props, options) => {
    return (
      <select onChange={(e) => props.onChange(e.target.value)}
        value={props.value}>
        {(() => {
          return options.map((value, key) => {
            return (
              <option value={value} key={key}>
                {value}
              </option>
            );
          });
        })()}
      </select>);
  }

  getDocumentStatus = () => {
    const token = this.props.token.Authorization;

    ExecuteRequest(
      GlamboxEndpoints.InfluencerDocument.getDocumentStatus,
      null,
      "GET",
      {
        Authorization: token
      },
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;
        if (statusCode === 200) {
          let status =
            result.map((documentStatus) => {
              return documentStatus.status;
            });

          this.setState({
            documentStatus: status
          });
        }

      }
    );

  }

  render() {

    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Admin Influencers : All Influencers</title>
        </Helmet>

        <h1>All Influencers</h1>

        {this.renderDatePickers()}
        {this.renderAllInfluencers()}
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  store: state,
  token: state.token.data,
  person: state.person.data

});

const mapDispatchToProps = (dispatch) => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  getReports: (startDate, endDate, callback) => {
    dispatch(InfluencerReportActions.get(startDate, endDate, callback));
  },
  partnerUpdate: (partner, callback) => {
    dispatch(PartnerInfoActions.savePartnerData(partner, callback))
  },
  isAdmin:(email, callback)=>{
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  }
});

AllInfluencers = connect(
  mapStateToProps,
  mapDispatchToProps
)(AllInfluencers);

export {
  AllInfluencers
};
